module.exports = __webpack_public_path__ + "img/icon_payment_status_second.438cf686.png";